import React from 'react';
const style = { fontSize: '18px', fontWeight: 'bold' };

const Total = ({ data, params }) => {
    const offset = params.length - Object.keys(data).length;
    let td = getValues(params.slice(offset), data);

    return (
        <tr>
            <td colSpan={offset}>Total</td>
            {td}
        </tr>
    );
};

function getValues(params, row) {
    return params.map(param => {
        const value = row[param];

        return (<td style={style} key={param}>{value}</td>);
    });
}

export default Total;



// WEBPACK FOOTER //
// ./src/scenes/AdkBannerDaily/components/Table/components/TotalRow/index.js